import { useNotificationBarStore } from 'src/hooks/stores'

export const useNotificationBar = () => {
  const { notificationBarStoreValue, setNotificationBarStoreValue } = useNotificationBarStore()

  const showNotificationBar = (text: string) => {
    setNotificationBarStoreValue({
      isShow: true,
      text,
    })
  }

  const hideNotificationBar = () => {
    setNotificationBarStoreValue({
      isShow: false,
      text: undefined,
    })
  }

  const updateText = (text: string) => {
    setNotificationBarStoreValue(previous => ({
      ...previous,
      text,
    }))
  }

  return {
    isShow: notificationBarStoreValue.isShow && !!notificationBarStoreValue.text,
    text: notificationBarStoreValue.text,
    showNotificationBar,
    hideNotificationBar,
    updateText,
  }
}
